import { supabase } from '../supabaseClient';

async function request(path, body) {
  const base = process.env.REACT_APP_STRIPE_CONNECT_URL;
  if (!base) throw new Error('Package service is not configured.');
  const { data, error } = await supabase.auth.getSession();
  if (error || !data?.session?.access_token) throw new Error('Please sign in again.');
  const response = await fetch(`${base.replace(/\/$/, '')}/stripe/therapist/${path}`, {
    method: body ? 'POST' : 'GET',
    headers: { Authorization: `Bearer ${data.session.access_token}`, 'Content-Type': 'application/json' },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) {
    const failure = new Error(result.error || 'Unable to load packages. Please retry.');
    failure.code = result.code;
    throw failure;
  }
  return result;
}
export const loadClientPackages = (offset = 0, client) => client
  ? request('client-packages/search', { ...client, offset, limit: 25 })
  : request(`client-packages?offset=${offset}&limit=25`);
export const quotePackageDecline = (id, scope) => request(`package-bookings/${encodeURIComponent(id)}/decline-quote?scope=${scope}`);
export const confirmPackageDecline = (id, confirmation) => request(`package-bookings/${encodeURIComponent(id)}/decline`, confirmation);
export const completePackageSession = id => request(`package-bookings/${encodeURIComponent(id)}/completion`, {});
